import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageComponent, Redirection } from '@tytapp/common';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent extends PageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private redirection = inject(Redirection);
  
  init() {
    this.route.paramMap.subscribe(params => {
      let token = params.get('token');
      if (token)
        this.redirection.go(`${environment.urls.app}/login/forgot/${token}`);
      else
        this.redirection.go(`${environment.urls.app}/login/forgot`);
    });
  }
}
